var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.688 12.375A1.69 1.69 0 010 10.687v-9A1.688 1.688 0 01.45.544C.768.2 1.22 0 1.687 0h14.624A1.69 1.69 0 0118 1.688v9a1.69 1.69 0 01-1.688 1.687H1.688zm-.563-1.688c0 .311.252.563.563.563h14.624c.311 0 .563-.252.563-.563v-8.86l-4.212 2.905L15.007 6.9a.563.563 0 01-.764.827l-2.53-2.339-1.368.945c-.395.272-.86.417-1.345.417s-.95-.144-1.345-.417l-1.369-.944-2.53 2.338a.566.566 0 01-.794-.031.564.564 0 01.03-.795l2.344-2.167-4.211-2.905v8.86zm7.17-5.282c.206.143.45.218.705.218.255 0 .499-.075.706-.218l6.207-4.28H2.087l6.207 4.28z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.02c1e13d960e244239bdaec5dadcd048.svg";
export { ForwardRef as ReactComponent };